import React from 'react';
import { useStatistics } from './StatiscticsContext';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import ArrowGrayLeftMore from '@/assets/icons/V3/arrow/ArrowGrayLeftMore.svg?react';
import ArrowGrayRightMore from '@/assets/icons/V3/arrow/ArrowGrayRightMore.svg?react';
// 좌/우 화살표 아이콘은 SVG 또는 임의의 텍스트로 대체 가능
const LeftArrow = () => (
  <button aria-label="이전 달" className="px-2 text-xl" style={{ userSelect: 'none' }}>
    {'<'}
  </button>
);
const RightArrow = () => (
  <button aria-label="다음 달" className="px-2 text-xl" style={{ userSelect: 'none' }}>
    {'>'}
  </button>
);

const MonthNavigator = () => {
  const { monthlySalesList, activedMonthlySales, setActivedMonthlySales } = useStatistics();

  // 현재 선택된 월의 인덱스
  const currentIndex = monthlySalesList.findIndex(
    (item) => item.Month === activedMonthlySales.Month,
  );

  // YYYY-MM → "YYYY년 M월"로 표시
  const getKoreanMonth = (monthStr: string) => {
    const [year, month] = monthStr.split('-');
    return `${year}년 ${Number(month)}월`;
  };

  // 이전/다음 월로 이동
  const moveMonth = (direction: 'prev' | 'next') => {
    if (direction === 'prev' && currentIndex > 0) {
      setActivedMonthlySales(monthlySalesList[currentIndex - 1]);
    }
    if (direction === 'next' && currentIndex < monthlySalesList.length - 1) {
      setActivedMonthlySales(monthlySalesList[currentIndex + 1]);
    }
  };

  if (!activedMonthlySales?.Month) return null;

  return (
    <div className="flex items-center gap-2">
      <span
        className="cursor-pointer"
        onClick={() => moveMonth('prev')}
        style={{ opacity: currentIndex === 0 ? 0.3 : 1 }}
      >
        {/* <ChevronLeft className="h-4 w-4" /> */}
        <ArrowGrayLeftMore />
      </span>
      <span className="text-gr-800 Title3S18">{getKoreanMonth(activedMonthlySales.Month)}</span>
      <span
        className="cursor-pointer"
        onClick={() => moveMonth('next')}
        style={{ opacity: currentIndex === monthlySalesList.length - 1 ? 0.3 : 1 }}
      >
        {/* <ChevronRight className="h-4 w-4" /> */}
        <ArrowGrayRightMore />
      </span>
    </div>
  );
};

export default MonthNavigator;
